import { TripContext } from 'contexts'
import { useContext } from 'react'
import { StopEquipment } from 'services/types'

export const useEquipmentService = () => {

    const tripContext = useContext(TripContext)

    const updateStopEquipments = async (stopEquipments: StopEquipment[]): Promise<void> => {
        const newStopEquipments = stopEquipments.map(equipment => {
            if (equipment.quantityOut == null)
                return { ...equipment, quantityOut: 0 }
            else
                return equipment
        })
        await tripContext.stopEquipments.bulkPut(newStopEquipments)
    }

    return {
        updateStopEquipments: updateStopEquipments
    }

}